import * as React from "react";
import { IPaymentHistory } from "./validators";

export const PaymentsHistoryContext = React.createContext<
  IPaymentHistory | undefined
>(undefined);

export function usePaymentsHistory() {
  const value = React.useContext(PaymentsHistoryContext);

  if (value === null) {
    throw new Error("`Missing PaymentsHistoryContext` in tree.");
  }

  return value;
}
